const gridSync = async (id, observerStrategy = 'vertical') => {
  const debug = true;
  const TAG = `[grid-sync ${id}]`;
  const log = (...args) => { debug && console.log(TAG, ...args); };

  const grid = document.getElementById(id);
  if (!grid) return log("kein grid – abbruch");
  const videos = Array.from(grid.querySelectorAll("video"));
  if (videos.length === 0) return log("keine videos – abbruch");
  log(`init mit ${videos.length} videos, strategy=${observerStrategy}`);

  let allReady = false;
  let suppress = 0;
  const inViewVideos = new Set();

  videos.forEach((v, i) => {
    v.muted = true;
    v.removeAttribute("autoplay");
    v.dataset.idx = String(i);
  });

  const isInstantPoster = (n) =>
    n?.nodeType === 1 &&
    n.tagName === "IMG" &&
    n.classList.contains("instant-video-fill__video");

  const stripPosters = () => {
    let removed = 0;
    videos.forEach((v) => {
      if (v.hasAttribute("poster")) { v.removeAttribute("poster"); removed++; }
      const fb = v.querySelector("img");
      if (fb) { fb.remove(); removed++; }
    });
    grid.querySelectorAll("img.instant-video-fill__video").forEach((img) => {
      img.remove(); removed++;
    });
    if (removed > 0) log("stripPosters: entfernt =", removed);
  };

  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach((n) => {
        if (isInstantPoster(n)) {
          log("MutationObserver: instant-poster entfernt", n);
          n.remove();
        }
      });
    }
  });
  mo.observe(grid, { childList: true, subtree: true });

  const setWrapperPaused = (v, paused) => {
    const w = v.closest(".instant-video-fill__wrapper");
    if (w) w.dataset.paused = paused ? "true" : "false";
  };

  const pauseVideo = (v) => {
    if (!v.paused) {
      v.pause();
      log(`  video[${v.dataset.idx}] pause()`);
    }
    setWrapperPaused(v, true);
  };

  const playVideo = (v) => {
    setWrapperPaused(v, false);
    v.muted = true;
    return v.play()
      .then(() => log(`  video[${v.dataset.idx}] play() ok`))
      .catch((err) => log(`  video[${v.dataset.idx}] play() FAIL`, err.name, err.message));
  };

  const pauseAll = () => {
    log(`pauseAll ↓ (suppress=${suppress})`);
    suppress++;
    videos.forEach(pauseVideo);
    stripPosters();
    queueMicrotask(() => { suppress--; log(`pauseAll ✓ suppress=${suppress}`); });
  };

  const playAll = () => {
    log(`playAll? allReady=${allReady}, inView=${inViewVideos.size}/${videos.length}`);
    if (!allReady || inViewVideos.size === 0) return log("  → playAll abgebrochen");
    suppress++;
    Promise.all(videos.map(playVideo))
      .finally(() => queueMicrotask(() => { suppress--; log(`playAll ✓ suppress=${suppress}`); }));
  };

  const resync = () => {
    if (inViewVideos.size > 0) playAll();
    else pauseAll();
  };

  // IO-Callback in einen Helper, der den Set-Wechsel detektiert und resync auslöst
  const handleViewChange = (mutator, label) => {
    const wasAny = inViewVideos.size > 0;
    mutator();
    const nowAny = inViewVideos.size > 0;
    if (wasAny !== nowAny) {
      log(`IO ${label}: anyVisible ${wasAny} → ${nowAny} (${inViewVideos.size}/${videos.length})`);
      resync();
    }
  };

  const waitCanPlay = (v) =>
    v.readyState >= 3
      ? Promise.resolve()
      : new Promise((res) => v.addEventListener("canplay", res, { once: true }));

  pauseAll();

  log("warte bis alle videos canplay melden…");
  const t0 = performance.now();
  await Promise.all(videos.map(waitCanPlay));
  log(`alle ready nach ${Math.round(performance.now() - t0)}ms`);
  allReady = true;

  if (observerStrategy === 'horizontal') {
    const io = new IntersectionObserver(
      (entries) => handleViewChange(() => {
        entries.forEach((e) => {
          if (e.intersectionRatio >= 0.5) inViewVideos.add(e.target);
          else inViewVideos.delete(e.target);
        });
      }, 'horizontal'),
      { threshold: [0, 0.5, 1] },
    );
    videos.forEach((v) => io.observe(v));
    log("IO aktiv (horizontal: pro video)");
  } else {
    const io = new IntersectionObserver(
      (entries) => handleViewChange(() => {
        const e = entries[entries.length - 1];
        if (e.isIntersecting) videos.forEach((v) => inViewVideos.add(v));
        else inViewVideos.clear();
      }, 'vertical'),
      { threshold: 0 },
    );
      log("IO aktiv (vertical: grid)");

    io.observe(grid);
  }

  videos.forEach((v, i) => {
    v.addEventListener("pause", () => {
      log(`event video[${i}] pause (suppress=${suppress})`);
      if (suppress === 0 && allReady) resync();
    });
    v.addEventListener("play", () => {
      log(`event video[${i}] play (suppress=${suppress})`);
      if (suppress === 0 && allReady) resync();
    });
    v.addEventListener("error", () => log(`event video[${i}] ERROR`, v.error));
  });
};
gridSync('HN4OYiDZRINtOqLJ');
gridSync('iPCERW5uELz2U8h5t', 'horizontal');
gridSync('iAnVv9wnEkjpvSX5L');